import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinus, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FOREX_LOTS } from "../../utils/orderFormat";

// Forex "Units" keypad. Pick a lot size (Micro 1,000 / Mini 10,000 / Standard
// 100,000), then +/- change the number of lots (Units = lot size × lot count).
// C clears the selection (Units reset to 0 → order can't be submitted until a
// lot is picked again). Dark styling matches the stocks/crypto number keypad.
//
// Kept COMPACT (no section header, tight padding) so it's roughly the same
// height as that number keypad — the popup opens upward inside the order
// ticket's scroll area, and a taller list would clip its top row against the
// panel edge (the "Micro lot" option would get cut off).
export default function ForexLotKeypad({
  lotSize,
  onSelectLot,
  onIncrement,
  onDecrement,
  onClear,
}) {
  return (
    <div>
      <div className="mb-1.5 grid gap-1.5">
        {FOREX_LOTS.map((l) => (
          <button
            key={l.key}
            type="button"
            onClick={() => onSelectLot(l.units)}
            className={`flex flex-col items-start rounded-lg px-3 py-1.5 leading-tight text-left transition-colors ${
              lotSize === l.units
                ? "bg-primaryColor text-white"
                : "bg-[#2a2a3e] text-white hover:bg-[#3a3a4e]"
            }`}
          >
            <span className="text-[13px] font-semibold">{l.label}</span>
            <span className="text-[10px] opacity-80">
              {l.units.toLocaleString()} units
            </span>
          </button>
        ))}
      </div>
      <div className="grid grid-cols-3 gap-1.5">
        <button
          type="button"
          onClick={onDecrement}
          disabled={!lotSize}
          className="rounded-lg bg-[#2a2a3e] py-1.5 text-white transition-colors hover:bg-[#3a3a4e] disabled:opacity-40"
        >
          <FontAwesomeIcon icon={faMinus} className="h-3.5 w-3.5" />
        </button>
        <button
          type="button"
          onClick={onIncrement}
          disabled={!lotSize}
          className="rounded-lg bg-[#2a2a3e] py-1.5 text-white transition-colors hover:bg-[#3a3a4e] disabled:opacity-40"
        >
          <FontAwesomeIcon icon={faPlus} className="h-3.5 w-3.5" />
        </button>
        <button
          type="button"
          onClick={onClear}
          className="rounded-lg bg-[#2a2a3e] py-1.5 text-sm font-medium text-white transition-colors hover:bg-red-600"
        >
          C
        </button>
      </div>
    </div>
  );
}
